<template>
  <div class="big-container">
    <table class="table trip-table">
      <thead class="thead-sc trip-table">
        <tr>
          <th scope="col">#</th>
          <th scope="col" class="">From</th>
          <th scope="col" class="">To</th>
          <th scope="col" class=" text-center">Date Range</th>
          <th scope="col" class=" text-center">Estimated Cost</th>
          <th scope="col" class=" text-center">Clients</th>
          <th scope="col" class=" text-center"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="trip in sortedTrips" :key="trip.id"> 
          <th scope="row">{{ trip.id }}</th>
          <td>{{ trip.fliesFrom.name }}</td>
          <td>{{ trip.fliesTo.name }}</td>
          <td class="text-center">{{ getFormattedDate(trip.typeFields.rangeFrom)  }} to {{ getFormattedDate(trip.typeFields.rangeTo)}} </td>
          <td class="text-center"> ${{ getSharedEstimated(trip.price,trip.passengers) }}</td>
          <td class="text-center"> {{ trip.passengersJoinedCount }}</td>
          <td class="text-center"><button class="btn btn-primary" @click="goToTripDetails(trip.id)"> See Details</button></td>
        </tr>
      </tbody>
    </table>
    
  </div>
</template>

<script>

import tripCardMixin from '@/mixins/tripCardMixin'

export default {
  name:'trip-table',
  mixins:[tripCardMixin],
  props: {
    trips:{
      type:Array,
      required:true
    }
  },
  methods: {
    goToTripDetails(tripId) {
      this.$router.push({
        name:'TripDetail',
        params: {
          trip:tripId
        }
      })
    },
    sortByStartingDate(tripA,tripB) {
      if (tripA.typeFields.rangeFrom > tripB.typeFields.rangeFrom ) {
        return 1 
      }
      if (tripA.typeFields.rangeFrom < tripB.typeFields.rangeFrom ) {
        return -1 
      }
      return 0
    }
  },
  computed: {
    sortedTrips() {
      if (this.trips.length < 1) {
        return []
      }
      let trips = this.trips
      return trips.sort(this.sortByStartingDate)
    }
  }
  
}
</script>

<style scoped>
  table.table.trip-table tr td,
  table.table.trip-table tr th {
    vertical-align:middle ;
  }

  .table .thead-sc.trip-table th {
    color: #fff;
    background-color: #1a2d74;
    /* border-color: #99a7db; */
  }


</style>